<div class="pmd-sidebar-scrollbar">
	<!--Sidebar-->
	<div class="d-flex justify-content-between align-items-center p-3">
		<div class="pmd-sidebar-brand">
			<a [routerLink]="getHomeLink()"
				class="navbar-brand d-flex justify-content-between align-items-center">
				<img src="assets/images/PurchaseSingleLogo.svg"
					class="fils-logo-icon" />
				<img src="assets/images/PurchaseLogo.svg"
					class="fils-logo" />
			</a>
		</div>
	</div>
	<ul class="nav flex-column pmd-sidebar-nav pmd-sidebar-nav_list">
		<ng-container *ngIf="!isPurchaseManagerView">
			<ng-container *ngFor="let section of topSections; index as i">
				<h6 class="text-d600 fw-semibold fs-14 title-header px-3"
					*ngIf="section.name">
					{{ section.name }}
				</h6>
				<ng-container *ngFor="let menu of section.menus">
					<li class="nav-item"
						routerLinkActive='active'>
						<a class="nav-link"
							[routerLink]="menu.path || (menu.subMenus?.length && menu.subMenus[0].path !== '/tag' ? menu.subMenus[0].path : null)"
							quicklink
							class="nav-link"
							[ngClass]="{'active': menu.name === activeMenu?.name}"
							[routerLinkActive]="menu.path ? 'active' : ''"
							(click)="openInnerSidebar(menu)">
							<i class="pmd-nav-item-icon"
								*ngIf="menu.svg"
								[innerHTML]="menu.svg | safeHtml">
							</i>
							<span class="flex-grow-1"
								*ngIf="menu.name"> {{ menu.name }}</span>
							<span *ngIf="menu.subMenus?.length"
								class="hide-on-brand">
								<svg width="6"
									height="11"
									viewBox="0 0 7 12"
									fill="none"
									xmlns="http://www.w3.org/2000/svg">
									<g clip-path="url(#clip0_4453_14990)">
										<path
											d="M0.721623 0.262639C1.01452 -0.0302546 1.48928 -0.0302545 1.78217 0.262639L6.78217 5.26264C6.92282 5.40329 7.0019 5.594 7.0019 5.79291C7.0019 5.99182 6.92282 6.18253 6.78217 6.32319L1.78217 11.3232C1.48928 11.6161 1.01451 11.6161 0.721623 11.3232C0.428737 11.0303 0.428747 10.5555 0.721623 10.2626L5.19135 5.79291L0.721623 1.32319C0.42873 1.03029 0.42873 0.555532 0.721623 0.262639Z"
											fill="#373737" />
									</g>
									<defs>
										<clipPath id="clip0_4453_14990">
											<rect width="7"
												height="12"
												fill="white" />
										</clipPath>
									</defs>
								</svg>
							</span>
						</a>
					</li>
				</ng-container>
				<hr *ngIf="topSections?.length !== i + 1">
			</ng-container>
		</ng-container>
		<ng-container *ngIf="isPurchaseManagerView && selectedMenu">
			<div class="nav-item cursor-pointer"
				(click)="onGoBackFromPurchaseManager()">
				<div class="nav-link">
					<span class="material-symbols-outlined">
						arrow_left_alt
					</span>
					<span class="fw-bold flex-grow-1 ms-2">Back To Dashboard</span>
				</div>
			</div>
			<li class="nav-item"
				*ngFor="let subMenu of selectedMenu.subMenus"
				routerLinkActive="active">
				<a class="nav-link nav-link-sub"
					[routerLink]="subMenu.path || null"
					quicklink
					routerLinkActive="active"
					(click)="openInnerSidebar(subMenu)">
					<i class="pmd-nav-item-icon"
						*ngIf="subMenu.svg"
						[innerHTML]="subMenu.svg | safeHtml">
					</i>
					<span class="flex-grow-1"
						*ngIf="subMenu.name">{{ subMenu.name }}</span>
				</a>
			</li>
			<!-- </ng-container> -->
		</ng-container>
	</ul>
	<ng-container>
		<hr class="px-4">
		<ul class="nav flex-column pmd-sidebar-nav cursor-pointer">
			<ng-container *ngFor="let section of bottomSections; index as i">
				<ng-container *ngFor="let menu of section.menus">
					<li class="nav-item">
						<a [routerLink]="menu.path || (menu.subMenus?.length && menu.subMenus[0].path !== '/tag' ? menu.subMenus[0].path : null)"
							quicklink
							class="nav-link"
							[ngClass]="{'active': menu.name === activeMenu?.name}"
							[routerLinkActive]="menu.path ? 'active' : ''"
							(click)="openInnerSidebar(menu)">
							<i class="pmd-nav-item-icon"
								*ngIf="menu.svg"
								[innerHTML]="menu.svg | safeHtml">

							</i>
							<span class="flex-grow-1">Settings</span>
							<span *ngIf="menu.subMenus?.length"
								class="hide-on-brand">
								<svg width="6"
									height="11"
									viewBox="0 0 7 12"
									fill="none"
									xmlns="http://www.w3.org/2000/svg">
									<g clip-path="url(#clip0_4453_14990)">
										<path
											d="M0.721623 0.262639C1.01452 -0.0302546 1.48928 -0.0302545 1.78217 0.262639L6.78217 5.26264C6.92282 5.40329 7.0019 5.594 7.0019 5.79291C7.0019 5.99182 6.92282 6.18253 6.78217 6.32319L1.78217 11.3232C1.48928 11.6161 1.01451 11.6161 0.721623 11.3232C0.428737 11.0303 0.428747 10.5555 0.721623 10.2626L5.19135 5.79291L0.721623 1.32319C0.42873 1.03029 0.42873 0.555532 0.721623 0.262639Z"
											fill="#373737" />
									</g>
									<defs>
										<clipPath id="clip0_4453_14990">
											<rect width="7"
												height="12"
												fill="white" />
										</clipPath>
									</defs>
								</svg>
							</span>
						</a>
					</li>
				</ng-container>
			</ng-container>
		</ul>
		<div class="pb-3 pt-2 px-3 d-flex align-items-center justify-content-between">
			<span class="pmd-avatar bg-secondary text-white fs-14">
				<div class="image-profile-page d-flex align-items-center gap-2"
					*ngIf="loggedInUserThumbnail else elseTemplate">
					<img [src]="loggedInUserThumbnail || 'assets/images/placeholder-image.png'"
						class="profile-img object-fit-cover"
						alt="placeholder-image.png" />
				</div>
				<ng-template #elseTemplate
					class="me-0 me-sm-2">
					{{loggedinUser.shortName?.slice(0, 3)}}
				</ng-template>
			</span>
			<div class="flex-grow-1 khr-logedin-user"
				[pmdTooltip]="loggedinUser.name"
				placement="top">
				<p class="mb-0 text-black fw-semibold text-truncate">
					{{ loggedinUser.name }}
				</p>
			</div>
			<span (click)="logout()"
				class="cursor-pointer logout-link"
				pmdTooltip="Logout"
				placement="top">
				<svg width="18"
					height="16"
					viewBox="0 0 16 14"
					fill="none"
					xmlns="http://www.w3.org/2000/svg">
					<path
						d="M0.833496 7C0.833496 3.42825 3.62631 0.500239 7.11084 0.5C8.11387 0.5 9.0629 0.743736 9.90381 1.17676L10.2573 1.37402L10.3384 1.43457C10.5099 1.59183 10.5537 1.8533 10.4292 2.06055C10.3048 2.26756 10.0537 2.3517 9.83447 2.27441L9.74268 2.23145L9.44678 2.06641C8.74249 1.70355 7.94953 1.5 7.11084 1.5C4.21382 1.50024 1.8335 3.94463 1.8335 7C1.8335 10.0554 4.21382 12.4998 7.11084 12.5C8.06918 12.5 8.96765 12.2341 9.74268 11.7686L9.83447 11.7256C10.0537 11.6483 10.3048 11.7324 10.4292 11.9395C10.5714 12.1762 10.494 12.4838 10.2573 12.626L9.90381 12.8232C9.06291 13.2563 8.11387 13.5 7.11084 13.5C3.62631 13.4998 0.833496 10.5717 0.833496 7ZM11.647 3.97949C11.8178 3.80896 12.081 3.78806 12.2749 3.91602L12.354 3.97949L15.02 6.64648C15.2153 6.84174 15.2153 7.15825 15.02 7.35352L12.354 10.0205C12.1588 10.2157 11.8423 10.2155 11.647 10.0205C11.4517 9.82525 11.4517 9.50874 11.647 9.31348L13.4595 7.5H6.00049C5.72435 7.5 5.50049 7.27614 5.50049 7C5.50049 6.72386 5.72435 6.5 6.00049 6.5H13.4595L11.647 4.68652L11.5825 4.6084C11.4544 4.41433 11.4761 4.15033 11.647 3.97949Z"
						fill="black" />
				</svg>
			</span>
		</div>
	</ng-container>
</div>